export const Translations_tr = {
    welcome:"Giriş sayfasına hoş geldiniz",
    userlogin: "Giriş Ekranı",
    loginbtn: "Giriş",
    password: "Şifre",
    logoutbtn : "Çıkış Yap",
    headertitle: "Müşteri Lisans Görüntüleme Portalı",
    headerwelcome: "Hoşgeldiniz",
    licensetabletitle: "Lisans Bilgilerim",
    productname: "Ürün Adı",
    licensekey: "Lisans Anahtarı",
    startdate: "Başlama Tarihi",
    enddate: "Bitiş Tarihi",
    cardtitle: "Lisans ve Yazılım Güncelleme",
    cardtext: "Yalnızca ürününüzle ilişkilendirilmiş lisans ve yazılım paketleri yüklenebilmektedir.",
    cardbtn: "Güncelleme İndir",
    licensetabletitle2: "Lisans Kullanım Bilgileri",
    offlineUpdatePackages: "Çevrimdışı Güncelleme Paketleri",
   };